import React, { useEffect } from 'react';

import { Checkbox, Dropdown, Icon, Space, Typography } from '@sravni/react-design-system';
import { ArrowDown, Bank, Cross, Flashlight, Menu, Shield } from '@sravni/react-icons';

import { FILTER_NAMES, FILTER_STATUS_OPTIONS } from '../../../../constants/reviews';
import { createReviewFilterParam, getSelectOptions } from '../../../../helpers/reviews';
import { useListQuery } from '../../../../store/hooks/reviews';
import { useUser } from '../../../../store/hooks/users';
import { IListHeaderProps } from '../../index';
import styles from '../../reviews-list-header.module.scss';

interface IProps extends Pick<IListHeaderProps, 'filters' | 'currentServerFilters' | 'typePage' | 'handleChange'> {
  isMobile?: boolean;
}

const statusIcons = {
  [FILTER_STATUS_OPTIONS.WithAnswers]: <Bank />,
  [FILTER_STATUS_OPTIONS.WithRates]: <Shield />,
  [FILTER_STATUS_OPTIONS.Resolved]: <Flashlight />,
  [FILTER_STATUS_OPTIONS.RatesRejected]: <Cross />,
  [FILTER_STATUS_OPTIONS.All]: <Menu />,
};

export const FilterStatus: React.FC<IProps> = ({ isMobile, filters, currentServerFilters, typePage, handleChange }) => {
  const user = useUser();
  const { filterBy } = useListQuery();

  const filterOptions = getSelectOptions(
    createReviewFilterParam(user ? 'reviewFullFilter' : 'reviewFilter', currentServerFilters),
    typePage,
  );

  const filterValue = filterOptions.find((item) => item.value === (filters[FILTER_NAMES.FILTER] || filterBy));

  const handleChangeFilter = (value) => {
    handleChange(value, FILTER_NAMES.FILTER);
  };

  useEffect(() => {
    if (isMobile) handleChangeFilter(filterValue.value);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  if (isMobile) {
    return (
      <Space direction={'vertical'} className={'h-mb-32'} size={16}>
        <Typography.Text size={16} strong>
          Статус
        </Typography.Text>
        {filterOptions.map((item, i) => (
          <Checkbox
            key={`filter-item-${i}`}
            className={styles.mobileCheckbox}
            checked={filterValue?.value === item.value}
            onClick={() => handleChangeFilter(item.value)}
          >
            <Icon icon={statusIcons[item.value]} className={'h-mr-12'} />
            {item.label}
          </Checkbox>
        ))}
      </Space>
    );
  }

  return (
    <Dropdown options={filterOptions} value={filterValue?.value} onChange={handleChangeFilter} optionsSort={false}>
      <div className={styles.dropdownButton}>
        {filterValue?.label}
        <Icon icon={<ArrowDown />} className={styles.dropdownButtonIcon} />
      </div>
    </Dropdown>
  );
};
